import { render, staticRenderFns } from "./TrainingItem.vue?vue&type=template&id=5d57e800&scoped=true"
import script from "./TrainingItem.vue?vue&type=script&lang=js"
export * from "./TrainingItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d57e800",
  null
  
)

export default component.exports